import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LINKS } from '@trip-ux/constants';
import { apiClient } from '../api.client';
import { RootStateOrAny } from 'react-redux';
import { Dispatch } from 'redux';
import { omitBy } from 'lodash';
import { AgencyDetails, ChangeHistory, Error } from './types';

export interface AgencySlice {
  isUpdateSuccess: boolean;
  isUpdateFailure: boolean;
  updateError: Error | null;
}

const initialState: AgencySlice = {
  isUpdateSuccess: false,
  isUpdateFailure: false,
  updateError: null,
};

const prepareUpdatePayload = payload => {
  const { formData , changeHistory} = payload;
  return omitBy(
    {
    status: formData.status,
    businessType: formData.businessType,
    organizationName: formData.organizationName,
    organizationNameInFrench: formData.organizationNameInFrench,
    affiliationCode: formData.affiliationCode,
    companyWebsite: formData.companyWebsite,
    programCode: formData.programCode,
    BDM: formData.BDM,
    rootOrganizationCode: formData.rootOrganizationCode,
    parentOrganizationCode : formData.parentOrganizationCode,
    paymentGateway: formData.paymentGateway,
    contract :formData?.contract,
    contacts : formData?.contacts,
    logoFile: formData.logoFile,
    changeHistory: changeHistory
    },
    value => value === null || value === undefined || value === ''
  );
};

export const updateAgency = createAsyncThunk(
  'updateByOrgCode',
  async (
    payload: {code: string; formData: AgencyDetails; changeHistory: ChangeHistory[]; },
    {
      getState,
      dispatch,
      rejectWithValue
    }: { getState: () => RootStateOrAny; dispatch: Dispatch; rejectWithValue: Function }
  ) => {
    try {
    const { code } = payload;
    const agencyPayload = prepareUpdatePayload({ ...payload });
      const config = {
        params: { organizationCode: code }
      };
      return await apiClient(dispatch, getState).put(LINKS.UPDATE_AGENCY, { ...agencyPayload }, config);
    } catch (error) {
      if (error && typeof error === 'object' && 'response' in error && error.response?.data) {
        return rejectWithValue(error.response.data as string);
      }
      return rejectWithValue('Unknown error');
    }
  }
);


export const agencySlice = createSlice({
  name: 'agency',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    }
  },
  extraReducers: builder => {
    builder
     .addCase(updateAgency.fulfilled, state => {
        state.isUpdateSuccess = true;
      })
      .addCase(updateAgency.rejected, (state, action) => {
        state.isUpdateFailure = true;
        state.updateError = action.payload as Error;
      });
  }
});

export const { resetState } = agencySlice.actions;


export const selectAgencyUpdateSuccess = state => state.agency.isUpdateSuccess;
export const selectAgencyUpdateFailure = state => state.agency.isUpdateFailure;
export const selectAgencyUpdateError = state => state.agency.updateError;

export default agencySlice.reducer;
